export default {
    SET_SELECTED_ROOM_ID(state, data) {
        state.selectedRoomId = data
    },
    SET_CHANNEL_TIME_FROM(state, data) {
        state.channelTimeFrom = data
    },
    SET_CHANNEL_TIME_TO(state, data) {
        state.channelTimeTo = data
    },
    SET_LAST_CHANNEL_TIME_FROM(state, data) {
        state.lastChannelTimeFrom = data
    },
    SET_LAST_CHANNEL_TIME_TO(state, data) {
        state.lastChannelTimeTo = data
    },
    SET_ROOMS(state, data) {
        state.rooms = data
    },
    SET_OPTION_VERSION_IDS(state, data) {
        state.optionVersionIds = data
        if (data.length == 1) {
            state.selectedVersionId = data[0]
        } else {
            state.selectedVersionId = null
        }
    },
    SET_SELECTED_VERSION_ID(state, data) {
        state.selectedVersionId = data
    },
    SET_CHANNEL_GROUP_FOCUS_POINT_MAP(state, data) {
        state.channelGroupFocusPointMap[data.channelGroup] = data.time
    },
 }